/** @deprecated */
export const SEND_META_SITE_ID_REQUEST = 'SEND_META_SITE_ID_REQUEST';
/** @deprecated */
export const SEND_META_SITE_ID_FAILED = 'SEND_META_SITE_ID_FAILED';

export const ACTIVATE_DIRECT_ACCESS_REQUEST = 'ACTIVATE_DIRECT_ACCESS_REQUEST';
export const ACTIVATE_DIRECT_ACCESS_SUCCEEDED = 'ACTIVATE_DIRECT_ACCESS_SUCCEEDED';
export const ACTIVATE_DIRECT_ACCESS_FAILED = 'ACTIVATE_DIRECT_ACCESS_FAILED';
